const iconSize = [16, null, 18];

const textSize = [14, null, 16];

const checkBoxTextMt = ["-2px", null, "-2px"];

const dashboardPenggunaCourseItemHeight = "500px";

export {
  iconSize,
  textSize,
  checkBoxTextMt,
  dashboardPenggunaCourseItemHeight,
};
